
<template>
  <div>
    <v-card style="border-radius:12px" v-if="oneClient.last_deal">
      <v-card-title primary-title class="pt-2 pb-1">
        <div class="title mb-0">Última negociação</div>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" :disabled="can_add_items" text icon style="border-radius: 7px;" color="success"
              @click="dialog_win_deal = true" rounded><v-icon small>mdi-thumb-up</v-icon></v-btn>
          </template>
          GANHOU
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" :disabled="can_add_items" text icon style="border-radius: 7px;" color="error"
              @click="loseDeal(); dialog_lose_deal = true" rounded><v-icon small>mdi-thumb-down</v-icon></v-btn>
          </template>
          PERDEU
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pt-1">
        <v-alert v-if="!Object.keys(last_deal).length" type="info" :value="true" style="border-radius: 12px;">
          Carregando negociação
          <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
        </v-alert>


        <template v-if="Object.keys(last_deal).length">
          <!-- {{last_deal}} -->

          <v-subheader>Detalhes
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text icon small color="primary" @click="dialog_edit_main_data = true"><v-icon
                    small>mdi-pencil</v-icon></v-btn>
              </template>
              Editar detalhes
            </v-tooltip>
          </v-subheader>
          <v-row class="pl-4" row wrap justify="space-between">
            <div>Criado em: {{
              new Date(last_deal.created_at.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR')
            }}
            </div>
            <div>Pagamento em: <b>{{ last_deal.payment_option.description }}</b>,
              <b>{{ last_deal.payment_time.description }}</b>
            </div>
          </v-row>

          <v-subheader>Produtos negociados
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" text icon small color="info" @click="can_add_items = !can_add_items"><v-icon small>{{
                  can_add_items? 'mdi-minus': 'mdi-plus'
                }}</v-icon></v-btn>
              </template>
              {{ can_add_items? 'Desabilitar': 'Permitir' }} adição e edição de itens
            </v-tooltip>
          </v-subheader>

          <v-col cols='12'>
            <deal-list-item :show_crud_item="can_add_items" :items="last_deal.deal_items"></deal-list-item>
          </v-col>

          <v-tooltip top v-if="can_add_items">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" style="z-index: 20; positon: absolute; bottom: 0px; left: 92%;" icon text color="success"
                @click="updateDealItems()">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </template>
            Atualizar itens em negociação
          </v-tooltip>
        </template>

      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_edit_main_data" max-width="500px" transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="title mb-0">Edição de pagamento</div>
        </v-card-title>
        <v-card-text>
          <deal-main-data :deal="last_deal"></deal-main-data>
        </v-card-text>
        <v-card-actions class="justify-end">
          <f-btn @click="dialog_edit_main_data = false" cancel></f-btn>
          <f-btn @click="updateDealDetails()" save></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <deal-win v-if="dialog_win_deal" @close="dialog_win_deal = false" :last_deal="last_deal"
      :updateDeal="winDeal"></deal-win>

    <v-dialog v-model="loading" persistent max-width="500px" transition="dialog-transition">
      <v-alert type="info" :value="true" style="border-radius: 8px;">
        {{ loadText }}...
        <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  components: {
    DealMainData: () => import('./mainData.vue'),
    DealListItem: () => import('./listItems.vue'),
    DealWin: () => import('./winDeal.vue'),

  },
  data() {
    return {
      key: null,
      loading: false,
      loadText: 'Atualizando negociação',
      last_deal: {},
      can_add_items: false,
      dialog_edit_main_data: false,
      dialog_win_deal: false,
      dialog_lose_deal: false,

    }
  },
  methods: {
    winDeal() {
      let d = {
        id: this.last_deal.id,
        status: 'won',
        deal_items_attributes: this.last_deal.deal_items,
        shipping_data: this.last_deal.shipping_data || {},
      }
      this.submitDeal(d)
    },
    loseDeal() {
      let c = confirm('Realmente perdeu a negociação?')

      if (c) {
        let d = {
          id: this.last_deal.id,
          status: 'lost',
          deal_items_attributes: this.last_deal.deal_items.map(o => { return { ...o, status: 'lost' } })
        }
        this.submitDeal(d)
      }
    },
    updateDealItems() {
      let d = {
        id: this.last_deal.id,
        deal_items_attributes: this.last_deal.deal_items
      }
      this.submitDeal(d)
    },
    updateDealDetails() {
      let d = {
        id: this.last_deal.id,
        payment_option_id: this.last_deal.payment_option_id,
        payment_time_id: this.last_deal.payment_time_id,
      }
      this.submitDeal(d)
    },
    submitDeal(d) {
      this.loading = true
      this.updateDeal(d).then(up_d => {
        this.loading = false
        up_d = up_d.data ? up_d.data.attributes : up_d
        if (up_d.status == 'open') {
          this.last_deal = {
            ...this.last_deal,
            ...up_d,
          }
          let type = 'success'
          let msg = 'Negociação atualizada'
          this.addNotification({type, msg})
        } else if (up_d.status == 'won') {
          let type = 'success'
          let msg = 'Negociação ganha! Pedido(s) criado(s) com sucesso'
          this.addNotification({type, msg})
          if (up_d.client_id) {
            this.$router.push(`/crm/clients/${up_d.client_id}`)
          } else {
            this.getOneClient(this.$route.params.id);
          }
          this.last_deal = {}
          this.oneClient.last_deal = null
        } else {
          let type = 'error'
          let msg = 'Negociação perdida. Vamos conseguir da próxima vez!'
          this.addNotification({type, msg})
          this.last_deal = {}
          this.oneClient.last_deal = null
        }
        this.loading = false
        this.loadText = null
        this.can_add_items = false
        this.dialog_edit_main_data = false
        this.dialog_win_deal = false
        this.dialog_lose_deal = false
      }).catch(err => {
        console.error(err);
        this.loading = false
        this.loadText = null
      })

    },
    getDeal() {
      if (this.oneClient && this.oneClient.last_deal) {
        this.loading = true
        this.loadText = this.loadText || 'Carregando'
        Api.Deal.show(this.oneClient.last_deal.id).then(r => r.data).then(deal => {
          this.last_deal = {
            ...this.oneClient.last_deal,
            ...deal.data.attributes,
          }
          this.loading = false
        }).catch(err => {
          console.error(err);
        })
      }
    },
    ...mapActions({
      getOneClient: 'Client/show',
      updateDeal: 'Deal/update',
      
      // function: 'Module/action'
    })
  },
  //PROBLEMA DO GAZZI -> UPDATE NESTED VAI DAR NO 
  mounted() {
    this.getDeal();
  },
  computed: {
    name() {
      return null
    },
    ...mapState({
      oneClient: state => state.Client.oneClient.data.attributes,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    can_add_items(nv, ov) {
      if (nv) {
        alert("Lembre-se de salvar as alterações da negociação no botão abaixo")
      } else if (nv == false) {
        this.last_deal.deal_items = this.last_deal.deal_items.filter(o => o.id)
      }
    },
    'oneClient.last_deal'(nv, ov) {
      if (!Object.keys(this.last_deal).length) {
        this.getDeal()
      }
    }
  },
}
</script>

<style scoped>

</style>